var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionAddPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    fill: "#E5E9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.008 112.04L136.677 112.04C139.157 112.04 141.159 109.973 141.191 107.526C141.191 105.046 139.188 103.043 136.709 103.043L112.008 103.043L112.008 78.3421C112.008 75.8625 110.005 73.8597 107.525 73.8597C105.046 73.8597 103.043 75.8625 103.043 78.3421L103.043 103.011L78.3739 103.011C75.8943 103.011 73.8915 105.078 73.8597 107.525C73.8597 110.005 75.8625 112.008 78.3421 112.008L103.043 112.008L103.043 136.709C103.043 139.188 105.046 141.191 107.525 141.191C110.005 141.191 112.008 139.188 112.008 136.709V112.04Z",
    fill: "#004076"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionAddPhoto);
export default __webpack_public_path__ + "static/media/connection-add-photo.a4fb5634f7554dca6e7ff68484046015.svg";
export { ForwardRef as ReactComponent };